import { z } from 'zod'

/**
 * Zod schema for contact form validation
 */
export const contactFormSchema = z.object({
  // Required fields
  first_name: z
    .string()
    .min(1, 'First name is required')
    .max(100, 'First name must be 100 characters or less'),
  last_name: z
    .string()
    .min(1, 'Last name is required')
    .max(100, 'Last name must be 100 characters or less'),
  email_primary: z
    .string()
    .min(1, 'Email is required')
    .email('Invalid email address'),

  // Optional fields
  job_title: z.string().max(100).optional().or(z.literal('')),
  email_secondary: z
    .string()
    .email('Invalid email address')
    .optional()
    .or(z.literal('')),
  phone_office: z.string().max(30).optional().or(z.literal('')),
  phone_mobile: z.string().max(30).optional().or(z.literal('')),
  phone_other: z.string().max(30).optional().or(z.literal('')),

  // Role flags
  is_primary_contact: z.boolean().optional(),
  is_billing_contact: z.boolean().optional(),
  is_operations_contact: z.boolean().optional(),

  // Communication preferences
  preferred_contact_method: z.enum(['email', 'phone', 'sms']).optional(),

  // Status
  status: z.enum(['active', 'inactive']).optional(),

  // Notes
  notes: z.string().max(5000).optional().or(z.literal('')),
})

// Input type for form defaultValues
export type ContactFormInput = z.input<typeof contactFormSchema>

// Output type after validation/parsing
export type ContactFormValues = z.output<typeof contactFormSchema>

// Default values for new contact form
export const contactFormDefaults: ContactFormInput = {
  first_name: '',
  last_name: '',
  email_primary: '',
  job_title: '',
  email_secondary: '',
  phone_office: '',
  phone_mobile: '',
  phone_other: '',
  is_primary_contact: false,
  is_billing_contact: false,
  is_operations_contact: false,
  preferred_contact_method: 'email',
  status: 'active',
  notes: '',
}
